"use client";

/*
 * Update the SDK with lifecycle events, requires window (client)
 */

import React, { useRef } from "react";
import { usePathname } from 'next/navigation';
import useOnLoadPublisher from "./use-onload-publisher";
import useResizePublisher from "./use-resize-publisher";

interface FeltEmbeddedComponentProps {
  children: React.ReactNode;
  id?: string;
}

export const FeltEmbeddedComponent: React.FC<FeltEmbeddedComponentProps> = React.memo(
  ({ children, id = usePathname() }) => {
    const ref = useRef<HTMLDivElement>(null);

    useOnLoadPublisher(id);
    useResizePublisher(id, ref);

    return (
      <div ref={ref} data-name="felt-content">
        {children}
      </div>
    );
  }
);

export default FeltEmbeddedComponent;
